import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { CommonModal } from '@src/common/CommonModal';

const Wrapper = styled('div', {});

export const LogoutSuccessModal = ({ closeAllModals }) => {
  return (
    <Wrapper>
      <CommonModal heading="Log Out Successful" closeAllModals={closeAllModals}>
        <Button onClick={closeAllModals}>Close</Button>
      </CommonModal>
    </Wrapper>
  );
};

LogoutSuccessModal.propTypes = {
  closeAllModals: PropTypes.func,
};

LogoutSuccessModal.defaultProps = {
  closeAllModals: () => {},
};
